export default __webpack_public_path__ + "static/media/bg2.dc90b9f4.PNG";